/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SchoolVM { 
    id?: number;
    schoolUuid?: string | null;
    description?: string | null;
    latitude?: number;
    longitude?: number;
    name?: string | null;
    isPublic?: boolean | null;
    ownerName?: string | null;
    level?: string | null;
    schoolType?: string | null;
    addressId?: number | null;
    level1?: string | null;
    level2?: string | null;
    level3?: string | null;
    level4?: string | null;
    createdBy?: number;
    updatedBy?: number;
    instituteType?: string | null;
    schoolType2?: string | null;
    numOfDevices?: number;
    headmasterId?: number | null;
    headmasterName?: string | null;
    hasReadingClub?: boolean | null;
    iscontrol?: boolean | null;
    maleCount?: number | null;
    femaleCount?: number | null;
    learnerCount?: number | null;
    teacherCount?: number | null;
}

